export default "__VITE_ASSET__DvOJ8Pn5__";